/**
 * Account flag hide_new_ui.
 * True (default): hide the task queue in the header, left menu, and dashboard.
 * False: show that task queue.
 */

const STORAGE_KEY = 'hide_new_ui';
const listeners = new Set();

const isHiddenValue = (value) => {
  if (value === false || value === 'false' || value === 0 || value === '0') {
    return false;
  }
  return true;
};

export const persistHideNewUi = (accountOrValue) => {
  let hidden = true;
  if (typeof accountOrValue === 'boolean') {
    hidden = accountOrValue;
  } else if (accountOrValue && typeof accountOrValue === 'object') {
    if (
      Object.prototype.hasOwnProperty.call(accountOrValue, 'hide_new_ui') &&
      accountOrValue.hide_new_ui !== undefined &&
      accountOrValue.hide_new_ui !== null
    ) {
      hidden = isHiddenValue(accountOrValue.hide_new_ui);
    }
  }
  const next = hidden ? 'true' : 'false';
  const prev = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.setItem(STORAGE_KEY, next);
  if (prev !== next) {
    listeners.forEach((listener) => {
      try {
        listener(hidden);
      } catch (e) {
        // A subscriber render error must not block the rest.
      }
    });
  }
};

/** Missing session value hides the new UI, matching the account default. */
export const isNewUiHidden = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === null || raw === undefined || raw === '') {
      return true;
    }
    return raw !== 'false';
  } catch (e) {
    return true;
  }
};

export const subscribeHideNewUi = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};



// WEBPACK FOOTER //
// ./src/utils/hideNewUi.js